<template>
  <div class="mb-3">
    <custom-callout :opened="panelOpen">
      <div class="row">
        <div
          class="col-sm-5 col-xl-3 my-2 border-right d-flex flex-column justify-content-center align-items-start"
          style="padding: 0 40px;"
        >
          <span
            class="badge badge-pill mb-2 font-14"
            :class="[`badge-${sufixType}`]"
          >
            {{ data.name }}
          </span>
          <div class="color-secondary-6 font-14">Número de Aviso:</div>
          <div class="font-weight-normal color-black font-14">
            <b>{{ data.code }}</b>
          </div>
        </div>
        <div class="col-sm-8 col-xl-8">
          <div class="color-secondary-6 font-14">
            Titulo:
          </div>
          <div class="font-weight-bold color-black font-14">
            {{ data.description }}
          </div>
          <div class="row mt-3">
            <div class="col-md-6 col-xl-3">
              <div class="color-secondary-6 font-14">
                Fecha de Publicación:
              </div>
              <div class="font-weight-bold color-black font-14">
                {{ data.publishDate | date }}
              </div>
            </div>
            <div class="col-md-6 col-xl-3">
              <div class="color-secondary-6 font-14">
                Fecha de Comienzo:
              </div>
              <div class="font-weight-bold color-black font-14">
                {{ data.startDate | date }}
              </div>
            </div>
            <div class="col-md-6 col-xl-2">
              <div class="color-secondary-6 font-14">
                Fecha de Presubasta:
              </div>
              <div class="font-weight-bold color-black font-14">
                {{ data.preAuctionDate | date }}
              </div>
            </div>
            <div class="col-md-6 col-xl-2">
              <div class="color-secondary-6 font-14">
                Fecha de Finalización:
              </div>
              <div class="font-weight-bold color-black font-14">
                {{ data.finishDate | date }}
              </div>
            </div>
            <div class="col-md-6 col-xl-2">
              <div class="color-secondary-6 font-14">
                Estatus:
              </div>
              <div class="font-weight-normal color-black font-14">
                <balloon
                  :bg="
                    `border-none text-center bg-${getStatusColor(
                      data.status.id
                    )}`
                  "
                  dot
                  :text="data.status.name"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-md-12 col-xl-1 text-right d-flex justify-content-end pr-4 align-items-center"
        >
          <action-button
            v-if="isDraft"
            i="fas fa-edit"
            variant="outline-success"
            @click="() => this.onEditHandler()"
          />
          <action-button
            v-if="!isDraft"
            i="fas fa-history"
            variant="outline-success"
            @click="() => this.onHistoryHandler()"
          />
          <action-button
            v-if="!isDraft"
            class="ml-3"
            i="far fa-file-export"
            variant="success"
            @click="() => this.onEditHandler()"
          />
        </div>
      </div>
      <template #edition>
        <div class="p-2">
          <div class="bg-white rounded p-3 mb-2 mx-0">
            <addendum-history
              :history="data.addendumHistory"
              :status="data.status"
            />
          </div>
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import {
  announcementStatuses,
  getStatusColor as _getStatusColor,
} from '@/utils/constants/announcementStatus.js';
import AddendumHistory from './AddendumHistory.vue';

export default {
  name: 'ResultRow',
  components: {
    CustomCallout,
    ActionButton,
    AddendumHistory,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      panelOpen: false,
    };
  },
  computed: {
    isDraft() {
      return this.data.status.id == announcementStatuses.Borrador;
    },
    sufixType() {
      return this.data.name
        .toLowerCase()
        .replaceAll(' ', '-')
        .normalize('NFD')
        .replaceAll(/[\u0300-\u036f]/g, '');
    },
  },
  methods: {
    onEditHandler() {
      this.$router.push({
        name: 'BidDocumentationEdit',
        params: { id: this.data.id },
      });
    },
    onHistoryHandler() {
      this.panelOpen = !this.panelOpen;
    },
    getStatusColor(statusId) {
      return _getStatusColor(statusId);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/brand_variables.scss';

.badge-pill {
  padding: 10px 25px;
}

.badge-servicios-profesionales,
.badge-educacion-especial {
  color: #d44d28;
  background-color: #fed8bc;
}

.badge-oficina-mejoramiento-escuelas-publicas {
  color: #173597;
  background-color: #dce4fe;
  text-wrap: auto;
}

.badge-infraestructura {
  color: #173597;
  background-color: #dce4fe;
}

.badge-transportacion {
  color: #1e8c9a;
  background-color: #b4e9eb;
}

.badge-remedio-provisional {
  color: #9a3277;
  background-color: #fadcf1;
}

.badge-oficina-central-de-compras {
  color: #089b05;
  background-color: #d2efd1;
}

.button-disabled {
  color: #bababa;
  border-color: #bababa;
}

.button-disabled:hover {
  color: #bababa;
  background-color: #f7f7f7;
  cursor: default;
}
</style>
